import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();
  useSeo({
    title: "页面未找到 - 出轨的妻子影视大全",
    description: "抱歉，你访问的页面不存在或已被移除，请返回首页继续浏览影视作品与影评内容。",
    keywords: "页面未找到,404,出轨的妻子",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 md:px-6 py-20 text-center">
      <p className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">404</p>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">
        抱歉，你访问的页面不存在或已被移除。
      </p>
      <p className="mt-1 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-grid-line" />
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}